import { useEffect, useState } from 'react'
import { useDebounceCallback } from 'usehooks-ts'

import { useHeadRequest } from 'js/lib/helpers/useHeadRequest'

export function useNotFoundData() {
    // Make a HEAD request to the current URL — See if it is redirected
    const [response, loading, error] = useHeadRequest(location.href)

    // We need to wait for the loading to finish before we can show the 404 content
    // But we don't want to wait for too long, so we use a debounce to avoid flickering
    const [actualLoading, setActualLoading] = useState(true)
    const debouncedSetActualLoading = useDebounceCallback(setActualLoading, 100)

    useEffect(() => {
        if (!loading && !error && response?.redirected) {
            history.replaceState(null, '', response.url)
            window.location.reload()
        }

        if (!loading) {
            debouncedSetActualLoading(false)
        }
    }, [response, loading, error, debouncedSetActualLoading])

    return [actualLoading, error]
}
